var _excluded = ["component", "goto"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Button, getValueAt, useCurrentBreakpoint } from '@kizi/core-components';
import React, { useMemo, useState, useEffect, createContext, useContext } from 'react';
export var SliderContext = /*#__PURE__*/createContext({
  currentPage: 0,
  currentSlide: [],
  setPage: function setPage() {
    return undefined;
  },
  numberOfPages: 0,
  setAutomaticSwipe: function setAutomaticSwipe() {
    return undefined;
  }
});
export var Slider = function Slider(_ref) {
  var children = _ref.children,
      elements = _ref.elements,
      controlledCurrentPage = _ref.currentPage,
      _ref$elementsPerPage = _ref.elementsPerPage,
      elementsPerPage = _ref$elementsPerPage === void 0 ? 1 : _ref$elementsPerPage,
      _ref$initialCurrentPa = _ref.initialCurrentPage,
      initialCurrentPage = _ref$initialCurrentPa === void 0 ? 0 : _ref$initialCurrentPa,
      _ref$spinRate = _ref.spinRate,
      spinRate = _ref$spinRate === void 0 ? 5000 : _ref$spinRate,
      _ref$automaticSpin = _ref.automaticSpin,
      automaticSpin = _ref$automaticSpin === void 0 ? false : _ref$automaticSpin;

  var _useState = useState(initialCurrentPage),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledCurrentPage = _useState2[0],
      setCurrentPage = _useState2[1];

  var currentPage = controlledCurrentPage !== null && controlledCurrentPage !== void 0 ? controlledCurrentPage : uncontrolledCurrentPage;

  var _useCurrentBreakpoint = useCurrentBreakpoint(),
      _useCurrentBreakpoint2 = _slicedToArray(_useCurrentBreakpoint, 1),
      currentBreakpoint = _useCurrentBreakpoint2[0];

  var _useState3 = useState(automaticSpin),
      _useState4 = _slicedToArray(_useState3, 2),
      isAutomaticSwipe = _useState4[0],
      setAutomaticSwipe = _useState4[1];

  var _elementsPerPage = useMemo(function () {
    return getValueAt(elementsPerPage, currentBreakpoint);
  }, [elementsPerPage, currentBreakpoint]);

  var numberOfPages = useMemo(function () {
    return elements.length / _elementsPerPage;
  }, [_elementsPerPage]);

  var isMobile = function isMobile() {
    if (window.matchMedia('(max-width: 767px)').matches) {
      // The viewport is less than 768 pixels wide
      return true;
    } else {
      return false;
    }
  };

  var handleScreenResize = function handleScreenResize() {
    if (isMobile()) {
      setAutomaticSwipe(false);
    }
  };

  useEffect(function () {
    // stop the automaticSpin for mobile
    if (isMobile()) {
      setAutomaticSwipe(false);
    }

    window.addEventListener('resize', handleScreenResize);
    return function () {
      window.removeEventListener('resize', handleScreenResize);
    };
  }, []);
  useEffect(function () {
    var timer;

    var automaticSwipe = function automaticSwipe(currentPage) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        currentPage < numberOfPages - 1 ? setCurrentPage(currentPage + 1) : setCurrentPage(0);
      }, spinRate);
    };

    if (isAutomaticSwipe) {
      automaticSwipe(currentPage);
    }

    return function () {
      return clearTimeout(timer);
    };
  }, [isAutomaticSwipe, currentPage]);
  var elementsToShow = useMemo(function () {
    var elementsToSkip = _elementsPerPage * currentPage;
    return elements.slice(0 + elementsToSkip, elementsToSkip + _elementsPerPage).map(function (elmt, i) {
      return /*#__PURE__*/React.cloneElement(elmt, {
        key: "slider-element-".concat(i)
      });
    });
  }, [currentPage, _elementsPerPage]);
  return children instanceof Function ? children(elementsToShow, currentPage, setCurrentPage, numberOfPages, setAutomaticSwipe) : /*#__PURE__*/React.createElement(SliderContext.Provider, {
    value: {
      currentSlide: elementsToShow,
      currentPage: currentPage,
      setPage: setCurrentPage,
      numberOfPages: numberOfPages,
      setAutomaticSwipe: setAutomaticSwipe
    }
  }, children);
};
export var SliderControl = function SliderControl(_ref2) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? /*#__PURE__*/React.createElement(Button, null) : _ref2$component,
      _goto = _ref2["goto"],
      props = _objectWithoutProperties(_ref2, _excluded);

  var _useContext = useContext(SliderContext),
      setPage = _useContext.setPage;

  return /*#__PURE__*/React.cloneElement(component, _objectSpread(_objectSpread(_objectSpread({}, component.props), props), {}, {
    onClick: function onClick(e) {
      if (component.props.onClick) component.props.onClick(e);
      setPage(_goto);
    }
  }));
};
export var CurrentSlide = function CurrentSlide() {
  var _useContext2 = useContext(SliderContext),
      currentSlide = _useContext2.currentSlide;

  return /*#__PURE__*/React.createElement(React.Fragment, null, currentSlide !== null && currentSlide !== void 0 ? currentSlide : null);
};